const STORAGE_KEY = 'stocktrack.subscription.checkout';

export function saveSubscriptionCheckout(plan) {
  if (!plan?.code) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        code: plan.code,
        name: plan.name,
        priceTzs: plan.priceTzs,
        highlights: plan.highlights || [],
        savedAt: Date.now(),
      })
    );
  } catch {
    /* ignore quota */
  }
}

export function readSubscriptionCheckout() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.code) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearSubscriptionCheckout() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
